export enum OrderTrackingOrderSource {
  SHOPIFY = "shopify",
  BIGCOMMERCE = "bigcommerce",
  COMMENTSOLD = "commentsold",
}

export enum OrderTrackingOrderPayloadProvider {
  REDO = "redo",
  MALOMO = "malomo",
}

export enum OrderTrackingIntegrationType {
  REDO = "redo",
  KLAVIYO = "klaviyo",
  ATTENTIVE = "attentive",
  POSTSCRIPT = "postscript",
}

export enum OrderTrackingOrderStatus {
  CREATED = "created",
  FULFILLED = "fulfilled",
  STALLED_IN_FULFILLMENT = "stalled-in-fulfillment",
  CANCELLED = "cancelled",
}

export enum OrderTrackingShipmentStatus {
  UNKNOWN = "unknown",
  PRE_TRANSIT = "pre_transit",
  IN_TRANSIT = "in_transit",
  OUT_FOR_DELIVERY = "out_for_delivery",
  DELIVERED = "delivered",
  AVAILABLE_FOR_PICKUP = "available_for_pickup",
  AVAILABLE_FOR_PICKUP_CARRIER = "available_for_pickup_carrier",
  STALLED_IN_TRANSIT = "stalled_in_transit",
  RETURN_TO_SENDER = "return_to_sender",
  DELIVERY_ATTEMPTED = "delivery_attempted",
  DELIVERY_FAILURE = "delivery_failure",
  SHIPMENT_CANCELLED = "shipment_cancelled",
  SHIPMENT_ERROR = "shipment_error",
}

export interface OrderTrackingOrderWebhookPayload {
  teamId: string;
  source: OrderTrackingOrderSource;
  orderStatus: OrderTrackingOrderStatus;
  rawOrder: unknown;
}

export interface OrderTrackingDispatchEventResult {
  dispatchedAt: Date;
  integrationType: OrderTrackingIntegrationType;
  success: boolean;
  message?: string;
}

export enum OrderTrackingEntityType {
  ORDER = "order",
  SHIPMENT = "shipment",
  TRACKER = "tracker",
}

export enum OrderTrackingEventCategory {
  WEBHOOK_RECEIVED = "webhook_received",
  DISPATCH_SENT = "dispatch_sent",
}

export enum OrderTrackingEventSource {
  // Platforms
  SHOPIFY = "shopify",
  BIGCOMMERCE = "bigcommerce",
  COMMENTSOLD = "commentsold",

  // Tracking providers
  EASYPOST = "easypost",
  TRACK123 = "track123",
  TRACK17 = "track17",
  SHIPPO = "shippo",
  SHIP24 = "ship24",

  // Integration destinations
  KLAVIYO = "klaviyo",
  ATTENTIVE = "attentive",
  POSTSCRIPT = "postscript",
  REDO = "redo",
}

export enum OrderTrackingOrderUpdateType {
  CREATED = "created",
  UPDATED = "updated",
  FULFILLED = "fulfilled",
  CANCELLED = "cancelled",
  LINE_ITEMS_UPDATED = "line_items_updated",
}

export enum OrderTrackingOrderFulfillmentStatus {
  UNFULFILLED = "unfulfilled",
  PARTIALLY_FULFILLED = "partially_fulfilled",
  FULFILLED = "fulfilled",
}

/**
 * Number of hours to suppress integration dispatches for backfilled orders.
 * During this period, state transitions and CRDB writes still happen,
 * but no notifications are sent to integrations (Klaviyo, Attentive, etc.).
 */
export const BACKFILL_QUIET_PERIOD_HOURS = 2;

/**
 * Default number of days to backfill orders when starting OTv2 workflows.
 */
export const OTV2_BACKFILL_DAYS = 30;
